// validators.js
export const intValidator =
  ({ allowMinus = false, label = "数値" } = {}) =>
  (value) => {
    if (value === "") {
      return { value: "", error: "" };
    }

    if (!/^-?\d+$/.test(value)) {
      return { value: null, error: `${label}は半角の整数で入力してください` };
    }

    const num = Number(value);
    if (!allowMinus && num < 0) {
      return { value: null, error: `${label}は0以上で入力してください` };
    }

    return { value: num, error: "" };
  };

export const decimalValidator =
  ({ scale = 2, allowMinus = false, label = "数値" } = {}) =>
  (value) => {
    if (value === "") {
      return { value: "", error: "" };
    }

    // 途中入力OK（"1." とか）
    const regex = new RegExp(`^-?\\d*(\\.\\d{0,${scale}})?$`);
    if (!regex.test(value)) {
      return {
        value: null,
        error: `「${label}」は半角の整数で入力してください`,
      };
    }

    // マイナス禁止チェック（文字列で）
    if (!allowMinus && value.startsWith("-")) {
      return { value: null, error: `${label}は0以上で入力してください` };
    }

    return { value, error: "" }; // ← Numberにしない
  };
